<fieldset>
  <legend>
    TypeMontant
  </legend>
  <app-form-input  [label]="'devise'" [name]="getUid()+'_SepAtt_devise'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeMontant.devise">
  </app-form-input>

  <app-form-input  [label]="'valeur'" [name]="getUid()+'_SepAtt_valeur'"
                  [parentForm]="parentForm" [rule]="''" [type]="'number'"
                  [value]="typeMontant.valeur">
  </app-form-input>
</fieldset>
